export default "__VITE_ASSET__DbXA_qqj__"